export default "__VITE_ASSET__BvD2Kras__"